import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { X, LogIn } from 'lucide-react';
import { cn } from "@/lib/utils";
import { scrollWithOffset } from "../../utils/scrollWithOffset";
import LgDropdownMenu from "../../components/languageDropDown/LanguageDropDown.component";

export default function HomeDrawer({ isOpen, setIsOpen, navLinks, scrolled, t: parentT, i18n: parentI18n }) {
  const { t: localT, i18n: localI18n } = useTranslation();
  const t = parentT || localT;
  const i18n = parentI18n || localI18n;
  const isRTL = i18n.language === 'ar';

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 md:hidden"
        onClick={() => setIsOpen(false)}
        aria-hidden="true"
      />
      
      {/* Drawer Panel */}
      <div 
        className={cn(
          "fixed top-0 h-dvh w-72 bg-background shadow-xl z-50 flex flex-col transition-transform duration-300 ease-in-out md:hidden",
          isRTL ? "right-0" : "left-0",
          isOpen 
            ? (isRTL ? "translate-x-0" : "translate-x-0") 
            : (isRTL ? "translate-x-full" : "-translate-x-full")
        )}
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
      >
        <div className="flex items-center justify-between p-4 border-b border-border">
          <h2 id="drawer-title" className="text-lg font-semibold text-foreground">
            {t('common.platformName', 'Al Saqr')}
          </h2>
          <Button variant="ghost" size="icon" onClick={() => setIsOpen(false)} className="text-muted-foreground">
            <X className="h-5 w-5" />
            <span className="sr-only">{t('common.closeMenu', 'Close menu')}</span>
          </Button>
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {navLinks.map((link) => (
            <Button
              key={link.titleKey}
              variant="ghost"
              asChild
              className="w-full justify-start text-muted-foreground hover:text-primary hover:bg-primary/10"
              onClick={() => setIsOpen(false)}
            >
              <HashLink 
                smooth 
                to={`/#${link.slug}`}
                scroll={(el) => scrollWithOffset(el, 60)}
              >
                {t(`homepage.header.nav.${link.titleKey}`)}
              </HashLink>
            </Button>
          ))}
          <hr className="my-2 border-border/50" />
          <Button
            variant="ghost"
            asChild
            className="w-full justify-start text-muted-foreground hover:text-primary hover:bg-primary/10"
            onClick={() => setIsOpen(false)}
          >
            <Link to="/login">
              <LogIn size={16} className={cn("transition-transform", isRTL ? "ml-2" : "mr-2")} />
              {t("homepage.header.login", "Login")}
            </Link>
          </Button>
        </nav>
        
        <div className="p-4 border-t border-border mt-auto">
          <LgDropdownMenu scrolled={false} />
        </div>
      </div>
    </>
  );
}
